export { UiSwitchComponent } from './ui-switch.component';
export { UiSwitchModule } from './ui-switch.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/ng2-ui-switch/dist/index.js
// module id = ../../../../ng2-ui-switch/dist/index.js
// module chunks = common